export const getLastMonth21st = () => {
  const today = new Date();
  let year = today.getFullYear();
  const month = String(today.getMonth()).padStart(2, '0');
  let day = 21;

  if (month < 0) {
    month = 11;
    year--;
  }
  return `${year}-${month}-${day}`;
};

export const formatDateForInput = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};